import { type ComponentProps, createContext, use } from 'react';
import { Table as AriaTable, composeRenderProps } from 'react-aria-components';
import clsx from 'clsx';

import styles from './Table.module.css';

type TableVariant = 'default' | 'slim';

const TableContext = createContext<TableVariant>('default');

export const useTableVariant = () => use(TableContext);

type Props = { variant?: TableVariant; bordered?: boolean } & ComponentProps<typeof AriaTable>;

export const Table = ({ children, variant = 'default', bordered, ...props }: Props) => (
  <TableContext.Provider value={variant}>
    <AriaTable
      {...props}
      data-variant={variant === 'slim' ? 'slim' : undefined}
      className={composeRenderProps(props.className, (className) =>
        clsx(className, styles.Table, {
          [styles.bordered]: bordered,
        }),
      )}
    >
      {children}
    </AriaTable>
  </TableContext.Provider>
);
